import { useState } from 'react'
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react"
import { EventType, OIDC_DEFAULT_SCOPES, PublicClientApplication } from "@azure/msal-browser"
import { AzureAdClient } from '../config/config'

export function getHostUrl() {
  return `${[window.location.protocol,'//',
  window.location.hostname,
  window.location.hostname === 'localhost' ? [':',window.location.port].join('') : ''].join('')}`
}

export function initApplicationAuth() {
  const azureAdAuth = {
    auth: {
     ...AzureAdClient.auth,
     redirectUri: getHostUrl()
    }
  }
  
  return new PublicClientApplication(azureAdAuth)
}

export function AuthProfile(props = {}) {
  const { instance, accounts, inProgress } = useMsal()
  let account
  // const [account, setAccount] = useState(null)

  const setAccount = (acct) => {
    account = acct
  }

  if (instance.getActiveAccount() && account === null) {
    console.log('instance had ActiveAccount', instance.getActiveAccount())
    setAccount(instance.getActiveAccount())
  } else {
    console.log('instance did not have ActiveAccount')
    const currentAccount = accounts.find((a) => {
      return a.tenantId === AzureAdClient.info.tenantId
    })
    console.log('currentAccount result:', currentAccount)
    if (currentAccount) {
      instance.setActiveAccount(currentAccount)
      setAccount(currentAccount)
    }
  }
  
  function login() { 
    instance.addEventCallback((message) => {
      console.info(message)
    })

    const req = {
      scopes: OIDC_DEFAULT_SCOPES
    }

    instance.ssoSilent(req).then((response) => {
      instance.setActiveAccount(response.account)
      setAccount(response.account)
      console.log('active account', account)
    }).catch((error) => {
      console.log(error)
      req.redirectStartPage = getHostUrl()
      instance.loginRedirect(req)
    })

    
  }
  
    const logout = async () => {
      await instance.logoutRedirect({
        account: account,
        logoutHint: account.idTokenClaims.login_hint,
        postLogoutRedirectUri: `${[getHostUrl(),'logout'].join('/')}`
      })
    }

    return (
      <>
        <AuthenticatedTemplate>
          <span>Welcome {account?.name || ''}!</span>
          <span><a href="#" onClick={() => logout()} role="button" style={{color:"white", paddingLeft: "2em"}}>Logout</a></span>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
          <span><a href="#" onClick={() => login()} role="button" style={{color:"white", paddingLeft: "2em"}}>Login</a></span>
          </UnauthenticatedTemplate>
        </>
    )
  }